import React from 'react';
import styles from './GroupedCard.module.css';

export function GroupedCard({ children }) {
  return <div className={styles.container}>{children}</div>;
}

export function GroupedCardColumn({ title, badge, children }) {
  return (
    <div className={styles.column}>
      <div className={styles.titleRow}>
        <h3 className={styles.title}>{title}</h3>
        {badge}
      </div>
      <div className={styles.rows}>{children}</div>
    </div>
  );
}

export function InfoRow({ label, value }) {
  return (
    <div className={styles.row}>
      <span className={styles.rowLabel}>{label}</span>
      <span className={styles.rowValue}>{value}</span>
    </div>
  );
}

export function InfoBlock({ label, children }) {
  return (
    <div className={styles.block}>
      <span className={styles.blockLabel}>{label}</span>
      <span className={styles.blockValue}>{children}</span>
    </div>
  );
}

export function Badge({ variant = 'neutral', children }) {
  const className = variant === 'success' ? styles.badgeSuccess : styles.badgeNeutral;
  return <span className={className}>{children}</span>;
}
